import {makeAutoObservable, reaction, when} from "mobx";
import * as Api from "api/api";
import {defaultAvatar} from "@/api/commonApi.js";
import AuthUtil from "@/utils/AuthUtil";

class User {
    token = "";
    userInfo = null

    constructor() {
        makeAutoObservable(this)

        this.loadData();
    }

    loadData(){
        this.token = AuthUtil.getToken() || "";
        this.userInfo = AuthUtil.getUserInfo() || null;
    }


    get id(){
        return this.userInfo?.id || 0;
    }

    get username(){
        return this.userInfo?.username || '';
    }

    get avatar(){
        return this.userInfo?.avatar || defaultAvatar;
    }

    get nickname(){
        return this.userInfo?.nickname || '';
    }

    get gender(){
        return this.userInfo?.gender || null;
    }

    get birthday(){
        return this.userInfo?.birthday || 0;
    }

    async fetchInfo() {
        await Api.userInfo();
        this.loadData();
    }

    get isLogin() {
        return !!this.token;
    }
}


const user = new User();

when(() => user.isLogin, async () => {
    await user.fetchInfo()
})

// reaction(() => user.token, (value) => {
//     // CookieUtil.save('token', value)
//     AuthUtil.setToken(value)
// })

// reaction(() => user.avatar, (value) => {
//     if (!value) {
//         user.avatar = defaultAvatar
//     }
// }, {
//     fireImmediately: true
// })

export default user;
